<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  let {
    oncancel
  }: {
    oncancel: () => void
  } = $props()

  let showModal = $state(false)
  let plan_name = $state("")
  let saving = $state(false)
  let button: HTMLButtonElement = $state(null)

  let user_count = appStore.users.filter((u) =>
    ["admin", "leader", "manager", "member", "recognition"].includes(u.role)
  ).length

  export function open(): void {
    showModal = true
  }

  async function cancelStandardSubscription(): Promise<void> {
    if (appStore.plan.name !== plan_name) {
      return
    }

    try {
      saving = true
      let resp = await xhr.patch(
        `/plans/${appStore.plan.id}/admin/billing/cancel_standard_subscription`
      )

      appStore.plan = resp.data.plan
      appStore.subscription = resp.data.subscription

      showModal = false
      toast("Your standard subscription has been cancelled.", "success")
      oncancel()
    } catch (e) {
      Honeybadger.notify(e)
      toast("There was an error canceling your standard subscription.", "error")
    } finally {
      saving = false
    }
  }

  $effect(() => {
    if (button) {
      if (appStore.plan.name === plan_name) {
        button.removeAttribute("disabled")
      } else {
        button.setAttribute("disabled", "disabled")
      }
    }
  })
</script>

<button
  class="flex items-center justify-center rounded-md border border-gray-300 bg-white py-2 px-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 hover:cursor-pointer"
  onclick={() => {
    plan_name = ""
    showModal = true
  }}
>
  Cancel Standard Subscription
</button>

<Modal bind:open={showModal}>
  <h3 class="text-center text-2xl max-w-sm mx-auto">
    Are you sure you want to cancel your standard subscription?
  </h3>
  {#if user_count > 3}
    <div class="mt-6 px-6 border rounded border-red-100 bg-red-50 py-2">
      <p class="text-red-700">
        You currently have <span class="font-bold">{user_count} members</span> on
        your plan.
      </p>
      <p class="text-red-700 mt-4">
        To cancel your Standard Subscription you must have a maximum of 3
        members on your plan. Please visit the Members tab to remove members
        until you have 3 or fewer members.
      </p>
    </div>
  {:else}
    <div class="mt-6">
      Please type <span class="font-semibold">{appStore.plan.name}</span> to confirm.
    </div>
    <div class="mt-2">
      <input type="text" bind:value={plan_name} class="w-full input" />
    </div>

    <div class="text-center mt-4">
      <button
        class="btn bg-gray-200 hover:bg-gray-300 cursor-pointer mr-10"
        onclick={() => (showModal = false)}
        tabindex="0"
      >
        No, Keep Subscription
      </button>

      <button
        class="btn danger cursor-pointer"
        bind:this={button}
        onclick={cancelStandardSubscription}
        tabindex="0"
      >
        Cancel Standard Subscription
      </button>
    </div>
  {/if}
</Modal>
